<template>
    <a data-turbolinks="false" :href="actionUrl" class="ActivityModalItem" :class="{ '--unread': unread }">
        <figure class="absolute">
            <img v-if="avatar" :src="avatar" class="spark-profile-photo" />
            <span v-else class="fa-stack fa-2x">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i :class="['fa', 'fa-stack-1x', 'fa-inverse', icon]"></i>
            </span>
        </figure>

        <div class="ActivityModalItem__content">
            <div class="meta">
                <p class="title" v-html="title"></p>
                <div class="date">{{ date | past | relative }}</div>
            </div>

            <div class="m-b-md" v-html="body"></div>

            <strong class="text-purple-500">
                {{ actionText }} <i class="fa fa-arrow-right"></i>
            </strong>
        </div>
    </a>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.ActivityModalItem {
    @apply text-sm;

    color: inherit !important;
    display: block;
    position: relative;
    padding: 20px 15px 20px 15px;
    text-decoration: none !important;
    transition: background-color 200ms;

    &:active,
    &:focus {
        background-color: @state-info-bg;
    }

    @media (hover: hover) {
        &:hover {
            background-color: @state-info-bg;
        }
    }

    &.--unread {
        background-color: @state-info-bg;
        transition: background-color 10s;
    }

    .ActivityModalItem__content {
        padding-left: 70px;

        .meta {
            display: flex;
            align-content: flex-end;
        }

        .title {
            flex: 1;
            font-weight: bold;
            line-height: 1.2;
            margin: 2px 0 10px;
        }

        .date {
            @apply text-xs;

            color: #aaa;
        }
    }

    .spark-profile-photo {
        height: 52px;
        width: 52px;
    }

    .fa-stack {
        color: @spark-border-color;
        font-size: 26px;
    }
}
</style>

<script type="text/babel">
export default {
    props: ['avatar', 'date', 'icon', 'title', 'body', 'unread', 'actionUrl', 'actionText'],
}
</script>
